import clsx from 'clsx';
import BasicLink from 'core/BasicLink';
import { usePathname } from 'next/navigation';

import cn from './style.module.sass';

type NavigationActiveProps = {
    linkName: string;
    childLinks?: string[];
    mainLink?: string;
};

export default function NavigationActive({
    linkName,
    childLinks = [],
    mainLink,
}: NavigationActiveProps) {
    const currentUrl = usePathname();
    const isActive = childLinks.includes(currentUrl);

    if (mainLink) {
        return (
            <BasicLink
                href={mainLink}
                activeClassName={cn['active']}
                className={clsx(cn['navigation'], isActive && cn['active'])}
            >
                {linkName}
            </BasicLink>
        );
    }

    return <div className={clsx(cn['navigation'], isActive && cn['active'])}>{linkName}</div>;
}
